import { HotlistDeclineReason } from '~/lib/hotlistDeclineReason'

export default {
  [HotlistDeclineReason.Salary]: 'Gehalt pass nicht',
  [HotlistDeclineReason.Location]: 'Der Standort passt nicht',
  [HotlistDeclineReason.LackingRemoteWork]: 'Zu wenig remote/HO wird angeboten',
  [HotlistDeclineReason.NoProductInterest]: 'Produkt sagt mir nicht zu',
  [HotlistDeclineReason.MismatchingRequirements]: 'Anforderungen entsprechen nicht meinem Profil',
  [HotlistDeclineReason.BadCompanyReputation]: 'Firma hat keinen guten Ruf',
  [HotlistDeclineReason.NoCareerOpportunities]: 'Keine Aufstiegsmöglichkeiten',
  [HotlistDeclineReason.NoCultureFit]: 'Kein Culture fit',
  [HotlistDeclineReason.Other]: 'Sonstiges',
}
